export const normalizeText = (value) => String(value || "").trim().toLowerCase();

export const normalizeBoolean = (value) => {
  if (value === true || value === "true" || value === 1 || value === "1") {
    return true;
  }

  return false;
};

export const normalizeChatList = (value) => {
  if (Array.isArray(value)) {
    return value;
  }

  if (value && typeof value === "object") {
    return Object.values(value);
  }

  return [];
};

export const getMessageText = (msg = {}) =>
  String(msg?.message ?? msg?.msg ?? msg?.text ?? msg?.content ?? "");

export const getMessageTimestamp = (msg = {}) => {
  const candidates = [
    msg?.time,
    msg?.createdAt,
    msg?.timestamp,
    msg?.currentTimeStamp,
    msg?.sentAt,
    msg?.date,
  ];

  for (const candidate of candidates) {
    if (candidate === null || candidate === undefined || candidate === "") {
      continue;
    }

    if (candidate instanceof Date && !Number.isNaN(candidate.getTime())) {
      return candidate.getTime();
    }

    if (typeof candidate === "number" && Number.isFinite(candidate)) {
      return candidate;
    }

    if (typeof candidate === "string") {
      const trimmed = candidate.trim();
      if (!trimmed) {
        continue;
      }

      const numeric = Number(trimmed);
      if (Number.isFinite(numeric)) {
        return numeric;
      }

      const parsed = Date.parse(trimmed);
      if (!Number.isNaN(parsed)) {
        return parsed;
      }
    }
  }

  return null;
};

const getSenderRole = (msg = {}) =>
  normalizeText(
    msg?.senderRole ||
      msg?.senderType ||
      msg?.role ||
      msg?.from ||
      msg?.sentBy ||
      msg?.author ||
      "",
  );

export const isAdminChatMessage = (msg = {}, currentAdminId = "") => {
  if (normalizeBoolean(msg?.isAdmin)) {
    return true;
  }

  const senderRole = getSenderRole(msg);
  if (["admin", "administrator", "support", "staff", "me"].includes(senderRole)) {
    return true;
  }

  const knownAdminId = String(msg?.adminId || msg?.senderId || msg?.createdBy || "");
  return Boolean(currentAdminId && knownAdminId && knownAdminId === String(currentAdminId));
};

export const normalizeChatMessage = (msg = {}, currentAdminId = "") => ({
  ...msg,
  message: getMessageText(msg),
  msg: msg?.msg ?? getMessageText(msg),
  isAdmin: isAdminChatMessage(msg, currentAdminId),
});

export const sortChatMessages = (messages = []) =>
  messages
    .map((message, index) => ({
      message,
      index,
      timestamp: getMessageTimestamp(message),
    }))
    .sort((a, b) => {
      if (a.timestamp !== null && b.timestamp !== null) {
        const diff = a.timestamp - b.timestamp;
        if (diff !== 0) {
          return diff;
        }
      } else if (a.timestamp !== null) {
        return -1;
      } else if (b.timestamp !== null) {
        return 1;
      }

      return a.index - b.index;
    })
    .map(({ message }) => message);

export const formatChatTime = (value) => {
  if (value === null || value === undefined || value === "") {
    return "No time available";
  }

  const date =
    value instanceof Date
      ? value
      : typeof value === "number"
        ? new Date(value)
        : typeof value === "string" && !Number.isNaN(Date.parse(value))
          ? new Date(Date.parse(value))
          : null;

  if (!date || Number.isNaN(date.getTime())) {
    return String(value);
  }

  const options = { hour: "2-digit", minute: "2-digit", hour12: true };
  return date.toLocaleTimeString([], options);
};

